// Tag trạng thái node dùng chung (ACTIVE/INACTIVE/MERGED) — preset semantic đã có trong
// NccAntdProvider token, không thêm màu mới.

import { Tag } from "antd";

export function StatusTag({ status }: { readonly status: string }) {
  if (status === "ACTIVE") return <Tag color="success">Hoạt động</Tag>;
  if (status === "MERGED") return <Tag color="warning">Đã sáp nhập</Tag>;
  return <Tag>Đã đóng</Tag>;
}
